<!-- @format -->

<template>
	<v-container fill-height>
		<v-row justify-center wrap class="d-flex align-start">
			<!-- USER TABs section -->
			<v-col xs6 md="2">
			</v-col>
			<v-col xs12 md="6">
				<v-card flat color="secondary" class="elevation-0" :tile="true">
					<v-toolbar color="background" class="elevation-0">
						<v-toolbar-title class="tertiary--text">Perfil de Usuario</v-toolbar-title>
					</v-toolbar>
					<v-tabs :vertical="tabBreakPoint" background-color="background" color="tertiary">
						<v-tab>
							<v-icon left> mdi-account-cog </v-icon>
							Editar Perfil
						</v-tab>
						<v-tab>
							<v-icon left> mdi-lock </v-icon>
							Contraseña
						</v-tab>
						<v-tab class="pr-10">
							<v-icon left> mdi-cog </v-icon>
							Settings
						</v-tab>
						<!-- User Bio -->
						<v-tab-item>
							<!-- input edit form -->
							<MaterialfyBasicCard cardMaxWidth="802" cardTitle="Perfil de Usuario"
								:cardShowSubHeader="false" cardSubHeaderText="Complete your profile"
								:cardShowAvatar="false">
								<template v-slot:crdInner>
									<validation-observer ref="observer" v-slot="{ invalid }">
										<v-container>
											<v-form ref="form" v-model="valid" lazy-validation>
												<br>
												<v-row wrap>
													<v-col xs12 md6>
														<validation-provider v-slot="{ errors }" name="Nombre"
															rules="required|max:10">
															<v-text-field v-model="name" :counter="10"
																:error-messages="errors" label="Nombre"
																required></v-text-field>
														</validation-provider>
													</v-col>
													<v-col xs12 md6>
														<validation-provider v-slot="{ errors }" name="Apellidos"
															rules="required|max:20">
															<v-text-field v-model="lastName" :counter="20"
																:error-messages="errors" label="Apellidos"
																required></v-text-field>
														</validation-provider>
													</v-col>
												</v-row>
												<v-row wrap>
													<v-col xs12 md12>
														<validation-provider v-slot="{ errors }" name="email"
															rules="required|email">
															<v-text-field v-model="email" :error-messages="errors"
																label="E-mail" required readonly></v-text-field>
														</validation-provider>
													</v-col>
												</v-row>
												<v-row justify="center">
													<v-btn :loading="loading" :disabled="invalid" color="success"
														@click="saveUser">
														Guardar
													</v-btn>
												</v-row>
											</v-form>
										</v-container>
									</validation-observer>
								</template>
								<template #crdActions>
									<!-- <v-btn class="mx-0 font-weight-light" color="tertiary"> Update Profile </v-btn> -->
								</template>
							</MaterialfyBasicCard>
						</v-tab-item>

						<v-tab-item>
							<MaterialfyBasicCard cardMaxWidth="802" cardTitle="Cambiar Contraseña"
								:cardShowSubHeader="false" cardSubHeaderText="Complete your profile"
								:cardShowAvatar="false">
								<template v-slot:crdInner>
									<v-container>
										<v-form ref="form" v-model="valid" lazy-validation>
											<br>
											<v-row wrap>
												<v-col xs12 md12>
													<v-text-field :type="show4 ? 'text' : 'password'"
														v-model="old_password" :error-messages="errors" label="Password"
														required></v-text-field>
													<br>
													<validation-provider vid="confirm" v-slot="{ errors }"
														name="Nueva Contraseña" rules="required|pass">
														<v-text-field :type="show4 ? 'text' : 'password'"
															v-model="new_password" :error-messages="errors"
															label="Nueva Contraseña" required></v-text-field>
													</validation-provider>
													<validation-provider v-slot="{ errors }"
														name="Confirmacion Password"
														rules="required|confirmar:@confirm">
														<v-text-field type="password" v-model="password1"
															:error-messages="errors" label="Confirme Nueva Contraseña"
															required></v-text-field>
													</validation-provider>
												</v-col>
												<!-- <v-col xs12 md12>
													<validation-provider vid="confirm" v-slot="{ errors }"
														name="Nueva Contraseña" rules="required|pass">
														<v-text-field :type="showPassword ? 'text' : 'password'"
															v-model="new_password" :error-messages="errors"
															label="Nueva Contraseña" required></v-text-field>
													</validation-provider>
												</v-col> -->
											</v-row>
											<!-- <v-row wrap>
												<v-col xs12 md12>
													<validation-provider v-slot="{ errors }"
														name="Confirmacion Password"
														rules="required|confirmar:@confirm">
														<v-text-field type="password" v-model="password1"
															:error-messages="errors" label="Confirme Nueva Contraseña"
															required></v-text-field>
													</validation-provider>
												</v-col>
											</v-row>-->
											<v-row justify="center">
												<v-btn class="text-none" color="success" min-width="92"
													variant="outlined" rounded :loading="loading" @click="changePass">
													Guardar
												</v-btn>
											</v-row>
										</v-form>
									</v-container>
								</template>
								<template #crdActions>
									<!-- <v-btn class="mx-0 font-weight-light" color="tertiary"> Update Profile </v-btn> -->
								</template>
							</MaterialfyBasicCard>
						</v-tab-item>
						<v-tab-item>
							<v-card flat color="primary" :tile="true">
								<v-card-text>
									<p>
										Fusce a quam. Phasellus nec sem in justo pellentesque facilisis. Nam eget dui.
										Proin
										viverra, ligula sit amet ultrices semper, ligula arcu tristique sapien, a
										accumsan nisi
										mauris ac eros. In dui magna, posuere eget, vestibulum et, tempor auctor, justo.
									</p>

									<p class="mb-0">
										Cras sagittis. Phasellus nec sem in justo pellentesque facilisis. Proin sapien
										ipsum,
										porta a, auctor quis, euismod ut, mi. Donec quam felis, ultricies nec,
										pellentesque eu,
										pretium quis, sem. Nam at tortor in tellus interdum sagittis.
									</p>
								</v-card-text>
							</v-card>
						</v-tab-item>
					</v-tabs>
				</v-card>
			</v-col>
			<!-- <v-col xs12 md4>
				<materialfy-color-card cardMaxWidth="500" :cardShowDivider="false" :cardShowActions="false"
					:cardShowInnerList="false" :cardShowInnerText="false">
					<template v-slot:crdInner>
						<v-avatar slot="offset" class="mx-auto d-block" size="130">
							<img :src="getAvatar" />
						</v-avatar>
						<v-card-text class="text-center">
							<h6 class="text-h5 text-gray font-weight-light mb-3">CEO / CO-FOUNDER - Cactus Jack</h6>
							<h4 class="text-h4 font-weight-normal">Travis Scott</h4>
							<p class="text-body-1 font-weight-light">
								You wrote that yourself? wow congrats dude, really, that's very cool. i just told
								everyone in my
								family about it, everybody thinks that's very impressive and asked me to congratulate
								you. they
								want to speak to you in person, if possible, to give you their regards. they also said
								they will
								tell our distant relatives in christmas supper and in NYE they will ignite fireworks
								that spell
								your name. i also told about this enormous deed to closer relatives, they had the same
								reaction.
								they asked for your address so they can send congratulatory cards and messages. my
								friends
								didn't believe me when i told them i knew the author of this gigantic feat, really, they
								were
								dumbstruck, they said they will make your name echo through years and years to come.
								when my
								neighbour found out about what you did, he was completely dumbstruck too, he wanted to
								know who
								you are and he asked (if you have the time, of course) if you could stop by to receive
								gifts,
								congratulations and handshakes. with the spreading of the news, a powerful businessman
								of the
								area decided to hire you as the CEO of his company because of this tremendous feat and
								at the
								same time an important international shareholder wants to sponsor you to give speeches
								and teach
								everybody how to do as you did so the world becomes a better place. you have become
								famous not
								only here but also everywhere, everybody knows who you are. the news spread really fast
								and
								mayors of all cities are setting up porticos, ballons, colossal boom speakers, anything
								that can
								make your name stand out more and see which city can congratulate you the hardest for
								this
								magnificent feat.
							</p>
							<v-btn color="primary" rounded class="font-weight-light"> Follow </v-btn>
						</v-card-text>
					</template>
					<template #crdActions>
						<div></div>
					</template>
					<template #crdInnerText>
						<div></div>
					</template>
				</materialfy-color-card>
			</v-col> -->
		</v-row>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex'
// import EventBus from '../../common/EventBus'
import UserService from '../../services/user.service'
import User from '../../models/user'
import { required, email, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'


setInteractionMode('eager')

extend('required', {
	...required,
	message: '{_field_} no puede estar vacio.',
})

extend('max', {
	...max,
	message: '{_field_} no puede ser mayor de {length} caracteres,',
})

extend('email', {
	...email,
	message: 'Email debe ser valido.',
})

extend('pass', {
	params: ['otherValue'],
	validate: (value) => {
		if (
			value === null ||
			value.length < 6 ||
			!/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[#?!@$%^&*-]).+$/.test(value)
		) {
			return false;
		}
		return true;
	},
	message:
		'La contraseña no cumple los requisitos.'
});

extend('confirmar', {
	params: ['target'],
	validate(value, { target }) {
		return value === target;
	},
	message: 'Las contraseñas no coinciden.'
});

export default {
	name: 'UserProfile',
	components: {
		ValidationProvider,
		ValidationObserver
	},
	data() {
		return {
			// Variables pantalla
			title: 'PERFIL',
			// Objetos
			user: new User('', '', ''),
			name: '',
			lastName: '',
			email: '',
			textFieldColor: 'secondary',
			tabBreakPoint: this.$vuetify.breakpoint.mobile ? false : true,

			// Models
			valid: '',
			old_password: '',
			new_password: null,
			password1: '',
			// Variables
			content: '',
			errors: '',
			show4: '',
			// Condicionales
			dialogPass: false,
			isOpenDialog: false,
			successful: false,
			// 18012025 Se añade nueva mejora LOADING INICIO
			loader: null,
			loading: false,
			// 18012025 Se añade nueva mejora LOADING FIN     
			// Web3
			walletAddress: '',
			qrCode: '',
			connector: null,
		}
	},
	computed: {
		...mapGetters(['getAvatar']),
	},
	mounted() {
		UserService.getUserProfile().then(
			response => {
				this.user.email = response.data.email
				this.user.username = response.data.username
				this.content = response.data
				this.name = this.content.name
				this.lastName = this.content.lastName
				this.email = this.content.email
				// console.log(response)
			},
			error => {
				this.content =
					(error.response && error.response.data && error.response.data.message) ||
					error.message ||
					error.toString();
				if (error.response && error.response.status === 401) {
					// EventBus.dispatch('logout')
					this.$store
						.dispatch('logout', this.user) //calls the login action and passes login info
						.then(() => this.$router.push('/')) //redirect to dash after login
						.catch((err) => {
							console.log(err)
							this.snackbar = true //shows error on wrong pass
						})
				}
			}
		)
	},
	methods: {
		async saveUser() {
			this.$refs.observer.validate().then(success => {
				if (!success) {
					return;
				}
				// 18012025 Se añade nueva mejora LOADING INICIO
				this.loader = 'loading'
				this.loading = true
				// 18012025 Se añade nueva mejora LOADING FIN
				// Wait until the models are updated in the UI
				this.$nextTick(() => {
					try {
						this.user.name = this.name
						this.user.lastName = this.lastName
						this.user.email = this.email

						UserService.saveUser(this.user).then(
							response => {
								setTimeout(() => (this.responseSave('success', response)), 2000)
							},
							error => {
								this.content =
									(error.response && error.response.data && error.response.data.message) ||
									error.message ||
									error.toString();
								setTimeout(() => (this.responseSave('error', error.response.data)), 2000)
							}
						);
					} catch (error) {
						setTimeout(() => (this.responseSave('error', error.response.data)), 2000)
					}
				});
			});
		},
		responseSave(response, msg) {
			console.log(response)
			console.log(msg)
			// this.$refs.dialogMessages.openModal()
			// this.$refs.dialogMessages.component = 'GUARDAR PERFIL'
			// this.$refs.dialogMessages.tituloDialog = 'GUARDAR PERFIL'
			// this.$refs.dialogMessages.msgError = msg
			// this.$refs.dialogMessages.isShow = true
			// if (response === 'success') {
			//     this.$refs.dialogMessages.types = 'success'
			//     this.successful = true
			// } else {
			//     this.$refs.dialogMessages.types = 'error'
			//     this.successful = false
			// }
		},
		closeAlert() {
			// 18012025 Se añade nueva mejora LOADING INICIO
			this.loading = false
			// 18012025 Se añade nueva mejora LOADING FIN
			if (this.successful) {
				this.$router.push('/home')
			}
		},
		changePass() {
			// 18012025 Se añade nueva mejora LOADING INICIO
			this.loader = 'loading'
			this.loading = true
			// 18012025 Se añade nueva mejora LOADING FIN
			UserService.changePass(this.old_password, this.new_password).then(
				response => {
					setTimeout(() => (this.responseSave('success', response)), 2000)
				},
				error => {
					this.content =
						(error.response && error.response.data && error.response.data.message) ||
						error.message ||
						error.toString();
					setTimeout(() => (this.responseSave('error', error.response.data)), 2000)
				}
			);
		}
	}
}
</script>
